import {FormHelperText, IconButton} from '@material-ui/core'
import {DeleteRounded} from '@material-ui/icons'
import React, {Fragment, useState} from 'react'
import { useDropzone } from 'react-dropzone'
import {DropzoneIcon, DropzoneMessage, DropzoneWrapper, FileWrapper, PdfIcon} from './styles'
import AcrobatLogo from '../../assets/SVG/acrobat-pro-cc.svg'

const DropInput = ({ field, form, helperText, accept, defaultMessage }) => {
  const [file, setFile] = useState(null)
  const error = form.errors[field.name]
  const touched = form.touched[field.name]
  const showError = touched && !!error

  const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
    accept: accept,
    onDropAccepted(files) {
      const [selectedFile] = files
      setFile(selectedFile)
      const reader = new FileReader()
      let dataUri
      reader.onabort = () => console.log('file reading was aborted')
      reader.onerror = () => console.log('file reading has failed')
      reader.onloadend = async () => {
        dataUri = reader.result
        form.setFieldValue(field.name, dataUri)
      }
      reader.readAsDataURL(selectedFile)
    },
  })

  const renderUploadMessage = (isDragAccept, isDragReject) => {
    if (isDragAccept) return 'Solte seus arquivos aqui.'
    if (isDragReject) return 'O Formato do arquivo não é permitido.'
    return defaultMessage
  }

  return (
    <Fragment>
      {file ? (
        <FileWrapper>
          <PdfIcon img={AcrobatLogo} />
          <DropzoneMessage>
            {file.path}
          </DropzoneMessage>
          <IconButton onClick={() => {
            setFile(null)
            form.setFieldValue(field.name, undefined)
          }} color="default">
            <DeleteRounded color="error" fontSize="small" />
          </IconButton>
        </FileWrapper>
      ) : (
        <DropzoneWrapper {...getRootProps()} isDragAccept={isDragAccept} isDragReject={isDragReject || showError}>
          <input {...getInputProps()} />
          <DropzoneIcon />
          <DropzoneMessage isDragAccept={isDragAccept} isDragReject={isDragReject || showError}>
            {renderUploadMessage(isDragAccept, isDragReject)}
          </DropzoneMessage>
        </DropzoneWrapper>
      )}
      <FormHelperText component="p" error={showError}>{showError ? error : helperText}</FormHelperText>
    </Fragment>
  )
}

export default DropInput
